import { Resizable } from 're-resizable';
import { color, Common, Widget, device } from '@stockbit/ui';
import styled, { css } from 'styled-components';

const { Flex, Button } = Common;
const { HumbergerButton: HumbergerButtonDefault } = Widget;

const Container = styled(Flex).attrs({ direction: 'column' })`
  border-left: 1px solid ${color.gainsboro};
  border-collapse: collapse;
  box-sizing: border-box;
  height: 100%;
  width: 35px;
`;

const WidgetContainer = styled(Flex)`
  background: ${color.light};
  display: none;
  z-index: 999;
  @media ${device.tablet} {
    height: 100vh;
    display: flex;
    position: fixed;
    top: 0;
    right: 0;
  }
`;

const WidgetWrapper = styled.div<{ isOpen: boolean }>(
  ({ isOpen }) => css`
    height: 100%;
    border: 1px solid ${color.gainsboro};
    border-right: none;
    overflow-y: hidden;
    width: ${isOpen ? '330px' : 0};
  `,
);

const Box = styled(Resizable).attrs({
  enable: {
    top: false,
    right: false,
    bottom: true,
    left: false,
    topRight: false,
    bottomRight: false,
    bottomLeft: false,
    topLeft: false,
  },
})`
  background-color: ${color.light};
  z-index: 99;
`;

const ButtonTransparent = styled(Button)`
  border: none;
  background: none;
  cursor: pointer;
  margin: 0;
  padding: 0;

  &:hover, &:focus {
    background: none;
    border: none;
  }
`;

const HumbergerButton = styled(HumbergerButtonDefault)`
  ${({ active }) =>
    active &&
    css`
      background: ${color.light};
      border-left: 1px solid ${color.gainsboro};
    `}
`;

interface ButtonProps {
  active?: boolean;
  $shouldRenderAfter?: boolean;
}

const ButtonWidget = styled.button<ButtonProps>`
  background: #fff;
  border: none;
  border-bottom: 1px solid #dadada;
  cursor: pointer;
  display: block;
  height: 60px;
  position: relative;
  width: 35px;

  &:hover {
    color: ${color.primary};
  }

  ${({ active }: ButtonProps) =>
    active &&
    css`
      color: ${color.primary};
    `}

  ${({ $shouldRenderAfter }: ButtonProps) =>
    $shouldRenderAfter &&
    css`
      &:after {
        content: "";
        display: block;
        height: 5px;
        width: 5px;
        background: ${color.primary};
        position: absolute;
        top: 21px;
        right: 8px;
        border-radius: 50%;
      }
    `}
`;

const SymbolLinkWrapper = styled.a`
  color: inherit;

  &:hover {
    color: inherit;
  }
`;

export {
  Box,
  Container,
  WidgetContainer,
  WidgetWrapper,
  ButtonTransparent,
  HumbergerButton,
  ButtonWidget,
  SymbolLinkWrapper
};
